import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from 'components/ScrollToTop';
import ErrorBoundary from 'components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ui/ProtectedRoute';
import NotFound from 'pages/NotFound';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import OperationsMonitor from './pages/operations-monitor';
import ExecutiveDashboard from './pages/executive-dashboard';
import PartnerAnalyticsHub from './pages/partner-analytics-hub';
import RevenueAnalytics from './pages/revenue-analytics';
import CatalogueGeoManagement from './pages/catalogue-geo-management';
import UserPartnerManagement from './pages/user-partner-management';
import VerificationsApprovals from './pages/verifications-approvals';
import OrderIntelligenceCenter from './pages/order-intelligence-center';
import ContentManagementSystem from './pages/content-management-system';
import Offer from 'pages/offer';
import SocialMediaManagement from 'pages/socials';
import SubscriptionManagement from 'pages/subscription-management';
import AdminsAndSubAdmins from 'pages/admins-sub-admins';
import GlobalConfiguration from 'pages/global-configuration';
import MainCategory from 'pages/main-category';
import SubCategory from 'pages/sub-category';
import PropertyAttributes from 'pages/property-attributes';
import RoleManagement from 'pages/role';
import PermissionManagement from 'pages/permission';
import UserManagement from 'pages/user';
import SellerDetails from 'pages/seller-details';
import CustomerManagement from 'pages/customer';
import CustomerDetails from 'pages/customer-details';
import SupportTicket from 'pages/support-ticket';
import ViewTicketPage from 'pages/support-ticket/view';
import EditTicketPage from 'pages/support-ticket/edit';
import SosLog from 'pages/sos-log';
import ViewSosLogPage from 'pages/sos-log/view';
import Booking from 'pages/booking';
import ViewBookingPage from 'pages/booking/view';
import PackageManagement from 'pages/packages';
import ServiceManagement from 'pages/services';
import ServiceCatalogManagement from 'pages/service-catalog';
import PropertyManagement from 'pages/properties';
import TourManagement from 'pages/tours';
import JobList from 'pages/job/JobList';
import CreateJob from 'pages/job/CreateJob';
import ApplicationList from 'pages/job/ApplicationList';
import JobApplicants from 'pages/job/JobApplicants';
import EditJob from 'pages/job/EditJob';
import CmsManagement from 'pages/cms';
import AddCmsPage from 'pages/cms/add';
import EditCmsPage from 'pages/cms/edit';
import ViewCmsPage from 'pages/cms/view';
import AddOfferPage from 'pages/offer/add';
import AddSubscriptionPage from 'pages/subscription-management/add';
import TermsConditions from 'pages/public/TermsConditions';
import PrivacyPolicy from 'pages/public/PrivacyPolicy';
import AboutUs from 'pages/public/AboutUs';
import AccountDeletion from 'pages/public/AccountDeletion';
import Appointment from './pages/appointment'
import ReviewManagement from './pages/review';
import ViewAppointmentPage from 'pages/appointment/view';
import MenuPage from 'pages/menu'
import SupportChat from 'pages/support-chat';

const Routes = () => {
  
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <ThemeProvider>
          <AuthProvider>
            <RouterRoutes>
              {/* Public Routes */}
              <Route path='/login' element={<Login />} />
              <Route path='/forgot-password' element={<ForgotPassword />} />
              <Route path='/reset-password/:token' element={<ResetPassword />} />

              {/* Public CMS Pages */}
              <Route path='/terms-conditions' element={<TermsConditions />} />
              <Route path='/terms-and-conditions-customer' element={<TermsConditions />} />
              <Route path='/terms-and-conditions-provider' element={<TermsConditions />} />
              <Route path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route path='/about-us' element={<AboutUs />} />
              <Route path='/account-deletion' element={<AccountDeletion />} />

              {/* Protected Routes */}
              <Route
                path='/'
                element={
                  <ProtectedRoute>
                    <ExecutiveDashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/admins'
                element={
                  <ProtectedRoute>
                    <AdminsAndSubAdmins />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/category/main'
                element={
                  <ProtectedRoute>
                    <MainCategory />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/category/sub'
                element={
                  <ProtectedRoute>
                    <SubCategory />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/property-attributes'
                element={
                  <ProtectedRoute>
                    <PropertyAttributes />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/packages'
                element={
                  <ProtectedRoute>
                    <PackageManagement />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/services'
                element={
                  <ProtectedRoute>
                    <ServiceManagement />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/service-catalog'
                element={
                  <ProtectedRoute>
                    <ServiceCatalogManagement />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/properties'
                element={
                  <ProtectedRoute>
                    <PropertyManagement />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/tours'
                element={
                  <ProtectedRoute>
                    <TourManagement />
                  </ProtectedRoute>
                }
              />

              {/* <Route
                path='/role'
                element={
                  <ProtectedRoute>
                    <RoleManagement />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/permission'
                element={
                  <ProtectedRoute>
                    <PermissionManagement />
                  </ProtectedRoute>
                }
              /> */}

              <Route
                path='/sellers'
                element={
                  <ProtectedRoute>
                    <UserManagement />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/sellers/:id'
                element={
                  <ProtectedRoute>
                    <SellerDetails />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/customers'
                element={
                  <ProtectedRoute>
                    <CustomerManagement />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/customers/:id'
                element={
                  <ProtectedRoute>
                    <CustomerDetails />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/support-tickets'
                element={
                  <ProtectedRoute>
                    <SupportTicket />
                  </ProtectedRoute>
                }
              />

              <Route
  path='/reviews'
  element={
    <ProtectedRoute>
      <ReviewManagement />
    </ProtectedRoute>
  }
/>

              <Route
                path='/support-tickets/:id'
                element={
                  <ProtectedRoute>
                    <ViewTicketPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/support-tickets/:id/edit'
                element={
                  <ProtectedRoute>
                    <EditTicketPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/sos-logs'
                element={
                  <ProtectedRoute>
                    <SosLog />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/sos-logs/:id'
                element={
                  <ProtectedRoute>
                    <ViewSosLogPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/bookings'
                element={
                  <ProtectedRoute>
                    <Booking />
                  </ProtectedRoute>
                }
              />

               <Route
                path='/appointment'
                element={
                  <ProtectedRoute>
                    <Appointment />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/bookings/:id'
                element={
                  <ProtectedRoute>
                    <ViewBookingPage />
                  </ProtectedRoute>
                }
              />


              <Route
                path='/menu'
                element={
                  <ProtectedRoute>
                    <MenuPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/jobs'
                element={
                  <ProtectedRoute>
                    <JobList />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/jobs/create'
                element={
                  <ProtectedRoute>
                    <CreateJob />
                  </ProtectedRoute>
                }
              />

              <Route

                path="/support-chat"

                element={
                  <ProtectedRoute>

                    <SupportChat />
                  </ProtectedRoute>


                }

              />

              <Route
                path='/jobs/applications'
                element={
                  <ProtectedRoute>
                    <ApplicationList />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/jobs/:jobId/applicants'
                element={
                  <ProtectedRoute>
                    <JobApplicants />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/jobs/:jobId/edit'
                element={
                  <ProtectedRoute>
                    <EditJob />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/profile'
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/settings'
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/operations-monitor'
                element={
                  <ProtectedRoute>
                    <OperationsMonitor />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/executive-dashboard'
                element={
                  <ProtectedRoute>
                    <ExecutiveDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/partner-analytics-hub'
                element={
                  <ProtectedRoute>
                    <PartnerAnalyticsHub />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/revenue-analytics'
                element={
                  <ProtectedRoute>
                    <RevenueAnalytics />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/catalogue-geo-management'
                element={
                  <ProtectedRoute>
                    <CatalogueGeoManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/user-partner-management'
                element={
                  <ProtectedRoute>
                    <UserPartnerManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/verifications-approvals'
                element={
                  <ProtectedRoute>
                    <VerificationsApprovals />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/order-intelligence-center'
                element={
                  <ProtectedRoute>
                    <OrderIntelligenceCenter />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/content-management-system'
                element={
                  <ProtectedRoute>
                    <ContentManagementSystem />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/cms'
                element={
                  <ProtectedRoute>
                    <CmsManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/cms/add'
                element={
                  <ProtectedRoute>
                    <AddCmsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/cms/edit/:id'
                element={
                  <ProtectedRoute>
                    <EditCmsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/cms/view/:id'
                element={
                  <ProtectedRoute>
                    <ViewCmsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/global-configuration'
                element={
                  <ProtectedRoute>
                    <GlobalConfiguration />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/offer'
                element={
                  <ProtectedRoute>
                    <Offer />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/social'
                element={
                  <ProtectedRoute>
                    <SocialMediaManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/offer/add'
                element={
                  <ProtectedRoute>
                    <AddOfferPage />
                  </ProtectedRoute>
                }
              />
              {/* <Route
                path='/subscription-management'
                element={
                  <ProtectedRoute>
                    <SubscriptionManagement />
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path='/subscription-management/add'
                element={
                  <ProtectedRoute>
                    <AddSubscriptionPage />
                  </ProtectedRoute>
                }
              />

               <Route
                path='/subscription-management/add'
                element={
                  <ProtectedRoute>
                    <AddSubscriptionPage />
                  </ProtectedRoute>
                }
              />

              <Route path="/appointments/:id" element={
                <ProtectedRoute>
                <ViewAppointmentPage />
                </ProtectedRoute>
                } />
              
              <Route path='*' element={<NotFound />} />
            </RouterRoutes>
          </AuthProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
